module.exports = __webpack_public_path__ + "static/20260423_HSE_Mat_Diff_Report_YE2025-4b07d265cf90599e9a9d1ffb67f9e3b7.pdf";